import { REQUEST_API_KEY } from 'modules/Api/constants';
import { selectApiKey } from 'modules/Api/selectors';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import injectReducer from 'utils/injectReducer';
import { BaseComponent } from '../../../components/BaseComponent';
import { Loader } from '../../../components/Loader';
import { LOGIN_DOMAIN } from './../constants';
import { loginReducer } from './../reducer';
import { Activate } from './activate';
import { Login } from './login';
import { Register } from './register';
import { PasswordReset } from './reset';
import { PasswordSet } from './set';
import { AzureLogin } from "../../../modules/Azure/login";
import config from '../../../env';

const Container = styled.div``;
/* eslint-disable react/prefer-stateless-function */
class LoginPageComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  render() {
    return (
      <>
        <Container>
          <Switch>
            <Route
              path="(.*)/one-time/:key"
              render={component => {
                if (this._oneTimeGate) return;
                this._oneTimeGate = true;

                let key = component.match.params.key;

                this.props.oneTimeLogin(key, result => {
                  this.props.history.push('/');
                });

                return <Loader onCard />;
              }}
            />

            <Route path="(.*)/register" component={Register} />

            <Route path="(.*)/activate/:code" render={component => <Activate code={component.match.params.code} />} />
            <Route path="(.*)/password-reset(.*)" component={PasswordReset} />
            <Route
              path="(.*)/password-set/:code"
              render={component => {
                let code = component.match.params.code;
                return <PasswordSet code={code} />;
              }}
            />
            <Route component={config?.auth_flow === 'AZURE' ? AzureLogin : Login} />
          </Switch>
        </Container>
      </>
    );
  }
}

LoginPageComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    apiKey: selectApiKey(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    oneTimeLogin: (oneTimeKey, callback) => {
      dispatch({
        type: REQUEST_API_KEY,
        oneTimeKey,
        callback,
      });
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const LoginPage = compose(
  injectReducer({ key: LOGIN_DOMAIN, reducer: loginReducer }),

  withRouter,
  withConnect,
)(LoginPageComp);
